import {
  InReviewResellerIcon,
  InReviewResellerIconSmall,
  VerifiedResellerIcon,
  VerifiedResellerIconSmall
} from "assets/icons";

import { ResellerVerificationStatus } from "../../constants";
import { ResellerVerificationStatusLabelProps } from "./ResellerVerificationStatusLabel.types";

const ResellerVerificationStatusLabel = ({
  status,
  onlyIcon = false
}: ResellerVerificationStatusLabelProps) => {
  switch (status) {
    case ResellerVerificationStatus.Verified:
      return onlyIcon ? (
        <VerifiedResellerIconSmall width={18} height={18} />
      ) : (
        <VerifiedResellerIcon />
      );
    case ResellerVerificationStatus.Pending:
      return onlyIcon ? (
        <InReviewResellerIconSmall width={18} height={18} />
      ) : (
        <InReviewResellerIcon />
      );

    default:
      return null;
  }
};

export default ResellerVerificationStatusLabel;
